import { UserPill } from "./AppHeader/UserPill";
import { ThemeToggle } from "./AppHeader/ThemeToggle";
import { SavedViewsControl } from "./AppHeader/SavedViewsControl";
import type { AuthUser } from "../types/inpact";
import type { SnapshotStatusResponse } from "../types/inpact";
import { SnapshotStatus } from "./SnapshotStatus";

interface AppHeaderProps {
  user: AuthUser | null;
  snapshot?: {
    status: SnapshotStatusResponse | null;
    isLoading: boolean;
    isRefreshing: boolean;
    statusError: Error | null;
    refreshError: Error | null;
    onRefresh: () => void;
  };
}

export function AppHeader({
  user,
  snapshot,
}: AppHeaderProps) {
  return (
    <header className="app-header" role="banner">
      <img src="/innodia_cristal.png" alt="" className="app-header__cristal" aria-hidden="true" />
      <span className="app-header__logo">INNODIA</span>
      <span className="app-header__logo-divider" aria-hidden="true" />
      <div className="app-header__brand">
        <span className="app-header__title">INPACT Dashboard</span>
        <span className="app-header__sub">Innodia Patient Associates</span>
      </div>
      <div className="app-header__center">
        {snapshot && (
          <SnapshotStatus
            status={snapshot.status}
            isLoading={snapshot.isLoading}
            isRefreshing={snapshot.isRefreshing}
            statusError={snapshot.statusError}
            refreshError={snapshot.refreshError}
            onRefresh={snapshot.onRefresh}
          />
        )}
      </div>
      <div className="app-header__right">
        <SavedViewsControl />
        <ThemeToggle />
        <span className="app-header__divider" aria-hidden="true" />
        <UserPill user={user} />
      </div>
    </header>
  );
}
